exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delete-email .modal-header {\n  border: 0px;\n  padding-bottom: 0px;\n  text-align: center;\n}\n.delete-email .modal-header p {\n  text-align: center;\n  padding-bottom: 0px;\n  -o-text-overflow: ellipsis;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: 100%;\n  white-space: nowrap;\n}\n.delete-email .modal-header .modal-title {\n  text-align: center;\n  font-size: 23px;\n}\n.delete-email .modal-footer {\n  border: 0px;\n}\n", ""]);

// exports
